<template>
  <div>
    <div class="top">
    <div style="height:120px;"></div>
      <div class="ioGvTH">
        <div class="sc-gKclnd">
          <div class="go-to-register" @click="()=>{this.$router.push({ name: 'Login' })}"><span class="zc">登录</span></div>
          <div class="ms-title">
            <div style="text-align: center;width: 50%;">
              <span class="tils">账号注册</span>
              <el-form :model="param"  ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username" label="登录账号：" label-width="180">
                    <el-input v-model="param.username" placeholder="username">
                    </el-input>
                </el-form-item>
                <el-form-item prop="password" label="登录密码：" label-width="180">
                    <el-input type="password" placeholder="password" v-model="param.password"">
                    </el-input>
                </el-form-item>
                <el-form-item prop="password" label="确认密码：" label-width="180">
                    <el-input type="password" placeholder="password" v-model="param.password"">
                    </el-input>
                </el-form-item>
                <el-form-item class="formit" prop="code" >
                    <el-input placeholder="请输入验证码" autocomplete="new-password" style="width: 54%;" v-model="param.code" />
                    <el-button :loading="loadingbutn" type="primary" @click="getIdentifyCode('login')" plain :disabled="disable">
                        <span>{{ buttonName }}</span>
                    </el-button>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" style="width: 100%;" @click="submitForm('login')">登录</el-button>
                    <!-- <el-button type="primary" @click="register()">注册</el-button> -->
                </div>
            </el-form>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div style="height: 120px; width: 1920px;background-color: #fafafc;"></div>
  </div>
</template>
<script>
export default {
    name: 'Register',
    data () {
        return {
          param:{

          },
          count: 59,
          loadingbutn: false,
          disable:false,
         buttonName :'获取验证码',
         rules: {
              phone: [
                  {
                      required: true,
                      message: '请输入手机号',
                      trigger: 'blur'
                  },
                  { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
              ],
              password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, message: "密码长度不小于6个字符", trigger: "blur" },],
              passwordnew: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, message: "密码长度不小于6个字符", trigger: "blur" },],
              code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
          },
        }
    },
    methods: {
      getIdentifyCode  (login)  {
            this.$refs[login].validateField('phone', (valid) => {
                if (valid) {
                    if (this.disable) {
                      this.disable = true
                    } else {
                      console.log('阿松大个');
                      this.loadingbutn = true
                        // getSmsCode({ phone: param.phone })
                        this.loadingbutn = false
                        // ElMessage.success("验证码发送成功一分钟有效!!!")
                        var timeout = setInterval(() => {
                            if (this.count < 1) {
                              this.disable = false;
                              this.buttonName = "获取验证码";
                              this.count = 59;
                                clearInterval(timeout);
                            } else {
                              this.disable = true;
                              this.buttonName = this.count-- + "s后重发";
                            }
                        }, 1000);
                    }
                }
            })
        }
    },
    mounted () {
    }
}
</script>

<style scoped>
.formit /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
}
.top {
    margin-top: 120px;   
    margin-bottom: 77px;
    display: flex;
    justify-content: center;
}
.tils{
  display: inline-block;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 51px
}
.ms-title{
  margin-top: 15%;
  display:flex;
  justify-content: center;
}
.go-to-register{
  cursor: pointer;
    height: 70px;
    width: 70px;
    background-image: url("https://img.alicdn.com/imgextra/i3/O1CN01yz6fEl1MwaRtkJyvf_!!6000000001499-55-tps-70-70.svg");
    position: absolute;
    top: 0px;
    right: 0px;
    text-align: right;
}
.zc{
    position: relative;
    top:12px;
    left:-4px;
}
.sc-gKclnd{
    width: 700px;
    background-color: rgb(255, 255, 255);
    height: 600px;
    overflow: hidden;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 15px;
}
</style>